module.exports = __webpack_public_path__ + "img/dragonhawk_rider_small.996c1892.png";